<div class="bottom-links-container">
    <ul class="bottom-links">
        <li><a routerLink="/legal-disclaimer">Legal Disclaimer</a></li>
        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
        <li class="copyright">2022 © Copyright Hisense</li>
    </ul>
</div>